import {
	connect
} from 'react-redux'
import LabelRestoreComponent from '../components/LabelRestoreComponent.jsx';
import {
	changeLabelRestoreValue,
	restoreCareLabels,
	cleanOrderLabelAlert,
	cleanOrderLabelInput
} from '../actions';

const mapStateToProps = (state) => ({
	roles: state.getIn(['authReducer', 'roles']),
	orderId: state.getIn(['labelReducer', 'orderId']),
	deletedLogIds: state.getIn(['labelReducer', 'deletedLogIds']),
	labelRestoreFormBean: state.getIn(['labelReducer', 'labelRestoreFormBean']),
	alertStyle: state.getIn(['labelReducer', 'alertStyle']),
	alertMessage: state.getIn(['labelReducer', 'alertMessage'])
})

const mapDispatchToProps = (dispatch) => ({
	setValue: (id, value) => {
		dispatch(changeLabelRestoreValue({
			id: id,
			value: value
		}))
	},
	restoreLabel: (bean) => {
		dispatch(restoreCareLabels(bean.toJS()));
	},
	cleanAlert: () => {
		dispatch(cleanOrderLabelAlert());
	},
	cleanInput: () => {
		dispatch(cleanOrderLabelInput());
	}
})

const LabelRestoreContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(LabelRestoreComponent)

export default LabelRestoreContainer;


// WEBPACK FOOTER //
// ./src/containers/LabelRestoreContainer.jsx